import { GraphQLField } from 'graphql';
import BooleanFiled from '@/components/FormBuilder/fields/BooleanField.vue';
import PreviewBooleanField from '@/components/FormBuilder/preview/PreviewBooleanField.vue';
import FieldComponentFactory from './FieldComponentFactory';

export default class BooleanField extends FieldComponentFactory {
  readonly component = BooleanFiled;

  readonly previewComponent = PreviewBooleanField;

  support(field: GraphQLField<any, any, any>): boolean {
    return this.typeInspector.isBooleanInput(field.type);
  }
}
